export default {
  customize: {
    home: '首页',
    user: '用户中心',
    userManage: '用户管理',
    createUser: '创建用户',
    editUser: '编辑用户',
    shop: '店铺中心',
    shopManage: '店铺管理',
    createShop: '创建店铺',
    editShop: '编辑店铺',
    // 订单中心
    orderCenter: '订单中心',
    allOrders: '全部订单',
    unpaidOrders: '未付款',
    alreadyPaid: '已付款',
    partUnpaidOrders: '部分付款',
    paidOrders: '已付款',
    pickingOrders: '配货中',
    orderEdit: '订单编辑',
    shippedOrders: '已发货',
    completed: '已完成',
    unpaidShippedOrders: '未付款已发货',
    requestRefundOrders: '申请退款',
    completedOrders: '交易完成',
    refundingOrders: '退款中',
    refundFinishedOrders: '退款完成',
    closedOrders: '已关闭',
    orderView: '查看订单',
    pleaseSelect: '请选择',
    UploadingImg: '图片上传中',
    jpgpngonly: '仅限JPG/PNG格式',
    multipleOrderNoAllowed: '可以填入多个订单号，请以英文逗号“,”分隔"',
    pleaseEnter: '请输入',
    cancelRefund: '取消退款',
    Yes: '是',
    emailNotificationSettings: '邮件通知设置',
    selectEmailNotificationRecipients: '请勾选接收通知的邮箱',
    refundToCreditMsg:
      '选择全部余额退款，则订单付款金额全部退回余额；如果不选择全部余额退款，则顾客使用余额和线下付款的部分退回余额，顾客线上付款部分请到MYPAY后台进行退款操作。',
    refundOperation: '退款操作',
    useMypayAdminForRefundOperation: '请使用MyPay后台操作退款',
    poliPayRefundOperation: '该笔订单中有POLi支付的部分，请线下转账退给用户: ',
    submitOrderDetail: '提交订单信息',
    saveWithoutDispatch: '保存订单信息不发货',
    orderAddressEdit: '订单地址修改',
    IncorrectShippingId: '请输入正确的快递单号',
    OrderDetailSaved: '订单信息保存成功',
    OrderDetailSaveFailed: '订单信息保存失败',
    OrderImgSaved: '订单图片保存成功',
    OrderImgSaveFailed: '订单图片保存失败',
    OrderImgDeleted: '订单图片删除成功',
    OrderImgDeleteFailed: '订单图片删除失败',
    OrderAddressSaved: '订单地址更新成功',
    OrderAddressSaveFailed: '订单地址更新失败',
    otherOperation: '其他操作',
    updateSuccessfully: '更新成功!',
    updateFailed: '更新失败!',
    settingSuccessfully: '设置成功!',
    settingFailed: '设置失败!',
    createdSuccessfully: '创建成功!',
    createFailed: '创建失败!',
    deletedSuccessfully: '删除成功',
    deleteFailed: '删除失败',
    noPermission: '没有权限!',
    between8To15Char: '长度在8到15个字符',
    between6To32Char: '长度在 6 到 32 个字符',
    between6To128Char: '长度在6到128个字符',
    printInvoice: '打印Invoice',
    noteComments: '顾客商家留言',
    includeComments: '顾客商家留言',
    initializeFailed: '初始化失败',
    filterOrderStatus: '过滤掉未付款和已关闭的订单',

    // 交易中心
    paymentChannel: '支付渠道',
    paymentSuccess: '支付成功',
    transactionCenter: '交易中心',
    transactionList: '交易列表',
    refundSuccess: '退款成功',
    pleaseSelectTransactions: '请选择交易',

    // 商品中心
    merchandiseCenter: '商品中心',
    brand: '商品品牌',
    categories: '商品分类',
    incompleteIncomplete: '商品信息不完整',
    categoryName: '分类名称',
    categoryLogo: '分类图标',
    categoryDescription: '分类描述',
    rankingWeight: '排序权重',
    menu: '菜单',
    h5HomeCategory: '移动端首页分类',
    // 商品品牌
    createBrand: '创建品牌',
    editBrand: '编辑品牌',
    viewBrand: '查看品牌',
    brandCreated: '创建品牌成功',
    brandCreatFailed: '创建品牌失败',
    brandUpdated: '更新品牌成功',
    brandUpdateFailed: '更新品牌失败',
    brandUnpromoted: '商品撤销推荐',
    // 商品分类
    createCategories: '创建分类',
    editCategories: '编辑分类',
    categoryCreated: '创建分类成功',
    categoryCreateFailed: '创建分类失败',
    // 商品管理
    management: '商品管理',
    createMerchandise: '创建商品',
    editMerchandise: '编辑商品',
    productDisabled: '商品下架成功',
    pleaseSpecifyBatchSpecialPrice: '请输入批量特价价格',
    pleaseChooseEndDate: '请选择截止日期',
    expired: '已过期',
    // 仓储中心
    stockCenter: '仓储中心',
    stockIn: '商品入库记录',
    stockOut: '商品出库记录',
    allStock: '全部库存记录',

    // 物流中心
    expressCenter: '物流中心',
    expressTemplateManagement: '快递模板管理',
    createTemplate: '创建运费模版',
    editTemplate: '编辑运费模版',
    expressCompanyList: '快递公司',
    CourierCompanyExist: '快递公司已存在',
    courierMsg1: '说明：影响包裹数量，每包裹有最低重量要求，影响最终运费总价',
    courierMsg2: '注：同快递类型产品多条规则符合，则只会应用最后一条。',
    shippingFeeCalcutation: '计算运费',
    parcelSplitRule: '快递分包规则',
    shippingFeeMsg1: '1.确定包裹数量',
    shippingFeeMsg2:
      '护肤品每包裹最多2件，化妆品每包裹混包最多4件，纯包最多6件',
    shippingFeeMsg3:
      '包裹可以同时放多种商品（包括化妆品、护肤品)，包裹里没有护肤品、化妆品则不需要分包',
    shippingFeeMsg4: '2.确定商品重量',
    shippingFeeMsg5: '包裹均重不足1kg按照均重1kg计算。即总重量=包裹数 * 1kg',
    shippingFeeMsg6: '3.费用',
    shippingFeeMsg7: '费用=总重量 * 单价',
    shippingFeeMsg8: '4.模板内能根据地区选子模板，优先使用子模板',
    shippingTemplateMsg1: '快递模板',
    shippingTemplateMsg2: '【类别】【单/混/无限制】【每包裹最大数量】',
    shippingTemplateMsg3: '【根据地区指定子模板】',
    shippingTemplateMsg4:
      '注：特殊地区则按照该模板计算，不会再考虑子模板的子模板',
    shippingTemplateMsg5: '【xx国家/xx地区】',
    shippingTemplateMsg6: 'xx模板',
    parcelRestriction: '包裹限制',
    cosmetics: '化妆品',
    skinCareProduct: '护肤品',
    single: '单',
    mix: '混',
    unrestricted: '无限制',
    minParcelWeight: '【包裹最低重量】',

    // 内容中心
    cmsCenter: '内容中心',
    pcCmsModules: '模块管理',
    pcCmsPages: '单页管理',
    pcNavigate: '编辑首页导航',
    pcAdBanner: '编辑首页Banner',
    editAdBanner: 'Banner编辑',
    createAdBanner: '创建Banner',
    pageSuffixTip: '后缀不允许含有空格，可用“-”代替',

    // 首页热销推荐
    pcHotSales: '编辑首页推荐',
    editHotSales: '热销推荐编辑',
    createHotSales: '创建热销推荐',
    deleteHotSales: '确认删除热销推荐？',
    mobileHotSalesStatus: '手机状态',
    pcHotSalesStatus: 'PC状态',
    brandList: '品牌列表',

    createPage: '创建页面',
    editPage: '编辑页面',
    searchPage: '搜索页面',
    reminder: '提示',

    // 发货仓库
    warehouse: '发货仓库',
    createWarehouse: '创建仓库',
    editWarehouse: '编辑仓库',

    // 店铺管理
    shopCenter: '店铺管理',
    pcShop: '店铺设置',
    goodsManagement: '批量上传商品',
    paymentMethodManagement: '支付管理',
    notificationManagement: '通知管理',
    themeManagement: '主题管理',
    themeCustomization: '主题自定义',
    theme: '主题',
    currentApplied: '当前已应用',
    themeOnlyApplyToHome: '注: 主题只会应用在商店移动端首页上',
    publish: '应用',
    preview: '预览',
    functionCurrentlyDisabled: '抱歉, 此功能暂未开放',
    clickToEnlargeImg: '点击放大图片',
    pcCurrentlyNoTheme: 'PC端暂时无需编辑主题',
    mobileTheme: '移动端主题',
    pcTheme: 'PC端主题',
    confirmToApplyTheme: '确认应用该主题',
    newArrivals: '新品上市',
    recomendedProducts: '商家推荐',
    limitedTimeDiscount: '限时折扣',
    aboutUs: '关于我们',
    clickToEditRelatedBanner: '<-- 点击分类来修改对应Banner图',
    createBanner: '创建Banner',
    editBanner: '编辑Banner',
    importData: '导入数据',
    goodsImportExportTip: '商品导入导出Tips',
    goodsImportMsg1: '1.商品导入操作为不可逆操作，请谨慎操作',
    goodsImportMsg2: '2.商品导入必须为特定格式xlsx（导出可见）',
    goodsImportMsg3: '3.商品导入导出仅支持无规格属性的单一SKU商品.',
    goodsImportMsg4:
      '4.每个商品导入的匹配为平台的 SPU 码。如果 SPU 码匹配上为其他字段更新操作。如果 SPU 码没有匹配上，则是创建商品操作.',
    goodsImportMsg5:
      '5.进行导入操作前，产品分类、产品品牌、发货仓库、折扣方案、运费模版必须每一项提前创建至少一个值.',
    goodsImportMsg6:
      '6.匹配产品分类、产品品牌、发货仓库、折扣方案、运费模版。使用创建好的对应名字即可。如果匹配不到，则默认使用查询的第一个值.',
    goodsImportMsg7: '7.导入导出都不会带上任何产品图片.',
    goodsImportMsg8:
      '8.导入新商品时候，会自动创建一张默认图片。真正上架的时候需要替换掉.',
    goodsImportMsg9: '9.导入导出都是耗时操作，请耐心等待。',
    importFailed: '导入失败',
    importSuccessfully: '导入成功',
    exportFailed: '导出失败',
    shopRequiredInfo: '店铺必要基本信息设置',
    shopAdminAccount: '店铺管理员账号',
    shopPaymentSetting: '店铺支付信息设置',
    shopWechatSetting: '店铺微信相关设置',
    shopCustomizationSetting: '店铺个性化信息设置',
    shopOtherInfoSetting: '店铺其他信息设置',
    Inactive: '未激活',
    Notified: '已通知',
    Processing: '处理中',
    Active: '已激活',
    noPosdata: '店铺暂无POS数据',
    importPosTips: '导入商品、分类是耗时操作，请耐心等待，勿执行其他操作。',

    // 分销中心
    distributionCenter: '分销中心',
    distributionList: '分销中心',
    withdrawableBalance: '可提现余额',
    walletTransaction: '钱包流水',

    // 会员中心
    memberCenter: '会员中心',
    memberList: '会员中心',
    memberView: '查看会员',
    discountPlans: '会员折扣',
    levelList: '等级列表',
    dataError: '数据错误',
    noComments: '无备注',
    editComments: '修改备注',
    selectLevel: '选择等级',

    // 店员中心
    assistantCenter: '店员中心',
    assistantList: '店员管理',
    roleList: '角色权限',
    addAssistant: '新增店员',
    // 统计中心
    statisticsCenter: '统计中心',
    salesStatistics: '销售额统计',
    ordersStatistics: '订单统计',
    goodsStatistics: '商品销售统计',
    membersStatistics: '用户统计',
    last7Days: '最近7天',
    last14Days: '最近14天',
    last30Days: '最近30天',
    sevenDays: '7天',

    // 活动中心
    promotionGoodsListUrl: '移动端活动商品列表页url',
    freeShippingGoodsListUrl: '移动端包邮商品列表URL',
    promotionDetail: '活动介绍',
    confirmDelete: '确定删除?',
    endDate: '截止日期',
    onlyShowsFreeShippingGoods:
      '在商品详情页面设置了包邮的商品会出现在这个url里面',
    onlyShowsLimitFreeShippingGoods:
      '在商品详情页面设置了满包邮的商品会出现在这个url里面',
    limitFreeShippingUrl: '移动端满包邮商品列表URL',
    create: '创建',
    freeShippingName: '包邮活动名称',
    freeShippingCap: '满包邮价格',
    spendMoreThan: '订单中购买该活动商品满 NZD $',
    willBeFreeShipping: ' 时候，这些商品运费为0.',
    deductNZD: ' 减 NZD $',
    promotionName: '活动名称',
    reach: '满',
    reduce: '减',
    enterFullReductionCondition: '请输入满减活动条件',
    promotionGoodsListPCUrl: 'PC端活动商品列表页url',
    pcFreeShippingGoodsListUrl: 'PC端包邮商品列表URL',
    pcLimitFreeShippingUrl: 'PC端满包邮商品列表URL',

    // 运营中心
    promotionCenter: '运营中心',
    freeExpressFeePromotion: '满包邮活动',
    expressFeePromotionDetails: '满包邮活动详情',
    fullReductionPromotion: '满减活动',
    noFullReductionPromotion: '无可选满减活动',
    fullReductionPromotionDetails: '满减活动详情',
    promotionUrl: '其他活动url',

    // 代理商
    withdrawDetail: '提现详情',
    agent: '代理商',
    agentList: '代理商列表',
    WithdrawList: '提现列表',
    agentPromotion: '代理商活动',
    createAgent: '创建新代理商',
    editAgent: '编辑代理商',
    walletHistory: '钱包历史',
    agentNotice: '目前代理商模块为公测版本',
    compulsory: '*为必填项',
    agentLevel: '代理商等级',
    shopURL: '店铺URL',

    // 优惠券
    coupon: '优惠券',
    couponCenter: '优惠券中心',
    couponList: '优惠券列表',
    createCoupon: '新建优惠券',
    couponStatistics: '优惠券统计',
    discountInputError: '优惠券抵扣/折扣金额输入错误',
    enterCouponValidTime: '请输入优惠券有效时间',
    enterUserMaxReceive: '请输入每个用户限领取数量',
    couponNotLessThan4Char: '优惠券领取码长度不得小于4位字母或数字',

    // 店铺公告
    noticeCenter: '公告中心',
    noticeList: '公告列表',

    // 首页
    numberOfProducts: '商品数量',
    numberOfMembers: '会员数量',
    mobileURL: '默认移动端地址',
    mobileNewURL: '移动端新地址',
    salesStatistic: '销售额统计',
    pcURL: '默认PC端地址',
    notCompletePaymentInfo: '您还未完善店铺支付信息，如果您还没有IE PAY账号，请点击下方链接申请：',
    haveIepayAccount: '如果您已有IE PAY账号，请点击',
    here: '这里',
    toCompletePaymentInfo: '，完善店铺支付信息。',
    customizedUrl: '自定义地址',

    add: '新增',
    delete: '删除',
    refresh: '刷新',
    edit: '编辑',
    operate: '操作',

    // 订单中心
    batchPrintInvoice: '批量打印Invoice',
    batchExportOrders: '批量导出订单',
    batchExportPickingInfo: '批量导出配货信息',
    exportExcel: '导出Excel',
    exportCurrentData: '导出当前数据',
    exportAllData: '导出所有数据',
    includeSKU: '商品名称追加SKU',
    statusChangeToPickingOnceExported: '导出订单信息后，订单状态将改为配货中。',
    confirm: '确定',
    orderGoods: '订单商品',
    orderMessage: '订单留言',
    recipientName: '收件人',
    recipientPhone: '收件人电话',
    identityNumber: '身份证',
    identityCard: '身份证',
    orderTimeRange: '订单时间范围',
    start: '开始时间',
    end: '结束时间',
    orderId: '订单号',
    enterTheOrderId: '输入订单号',
    search: '搜索',
    lastWeek: '最后一周',
    lastMonth: '最后一个月',
    lastThreeMonths: '最后三个月',
    amountofGoods: '商品金额',
    shippingFee: '运费金额',
    totalFee: '总金额',
    orderStatus: '订单状态',
    orderCreateAt: '下单时间',
    view: '查看',
    express: '物流',
    orderSort: '订单排序',
    consigneePhone: '收货人手机',
    senderName: '发货人',
    senderPhone: '发货人电话',
    senderAddress: '发货地址',
    more: '更多',
    collapse: '收起',
    offlinePayment: '线下转账',
    pickup: '自取',
    unbound: '未绑定',
    pleaseSelectOrders: '请选择订单',
    createdDesc: '订单创建时间从新到旧',
    createdAsc: '订单创建时间从旧到新',
    updatedDesc: '订单更新时间从新到旧',
    updatedAsc: '订单更新时间从旧到新',
    ordersPerPage: '每页订单数',
    no: '否',
    notApplicable: 'N/A',
    none: '无',
    orderFeeDetai: '订单金额详情',
    originalGoodsFee: '商品原价',
    originalShippingFee: '运费原价',
    discountedGoodsFee: '商品折扣后金额',
    discountedShippingFee: '运费折扣后金额',
    orderShopPrice: '采购订单金额',
    orderFinalPrice: '订单支付总金额',
    barcode: '条形码',
    profit: '分润',
    costFee: '成本',
    sellPrice: '售价',
    sellShippingFee: '运费',
    sellTotalFee: '总价',
    receiver: '收货人',
    receiverPhone: '收货人电话',
    writeOffDetail: '订单商品已提货',
    writeOffSuccessfully: '核销成功',
    writeOffFailed: '核销失败',
    displayInOrderLogs: '显示在订单操作日志',
    displayInOrders: '在订单详情中展示给客户',
    displayOrderComments: '客户订单备注, 在Invoice以及导出订单excel中可显示',

    // 订单详情
    orderDetail: '订单详情',
    customerId: '下单用户',
    paymentMethod: '支付方式',
    shippingAddress: '收货地址',
    includeShippingAddress: '包括收货地址',
    shippingPerson: '收货人',
    customerMessage: '客户留言',
    paymentTime: '支付时间',
    deliveryTime: '发货时间',
    completeTime: '完成时间',
    productList: '商品列表',
    productThumbnail: '产品图',
    productAbbreviation: '产品简称',
    productTitle: '产品名称',
    productId: '产品ID',
    unitPrice: '单价',
    amount: '金额',
    discountInformation: '优惠信息',
    total: '合计',
    orderOperation: '订单操作',
    modifyTheOrderPrice: '修改订单价格',
    expressNumber: '快递单号',
    goodsName: '商品名称',
    expressDetails: '快递详情',
    operationNotes: '本次操作备注',
    closed: '已关闭',
    unpaid: '未付款',
    paid: '已付款（待发货）',
    partialyPaid: '部分付款',
    unpaidShipped: '未付款已发货',
    picking: '配货中',
    shipped: '已发货（待完成）',
    transactionComplete: '交易完成',
    requestARefund: '申请退款',
    refundCompleted: '退款完成',
    submit: '提交',
    orderOperationLog: '订单操作日志',
    operator: '操作者',
    operatingTime: '操作时间',
    operationalAttributes: '操作属性',
    operationDetails: '操作详情',
    modifyAmountofGoods: '商品金额(NZ$)',
    modifyShippingFee: '运费金额(NZ$)',
    modifyAttachment: '订单附加图片',
    isRefund: '是否全部退款至余额',
    orderAttachment: '订单附件',
    isPickUp: '运送方式',
    onlyPickUp: '只允许自取',
    isAgentOrder: '订单类型',
    isPickUpOrder: '自取订单',
    paymentDetail: '支付详情',
    viewPaymentDetail: '查看支付详情',
    expressCompany: '快递公司',
    expressTime: '时间',
    expressContext: '详情',
    operationType: '操作类型',
    addTrackingNumber: '添加快递单号',
    messageToCustomer: '给顾客留言',
    orderComment: '订单备注',
    quantity: '数量',
    orderType: '订单类型',
    generalOrder: '普通订单',
    agentOrder: '分销订单',
    orderFee: '订单支付总金额',
    customerRemark: '备注名',
    orderAddress: '收货信息',
    orderSender: '发货信息',
    orderTime: '订单时间',
    orderActivity: '订单参与的运营活动',
    orderCoupon: '订单使用的优惠券',
    promotionActivity: '运营活动',
    couponActivity: '优惠券',
    writeOffButton: '已提货并完成订单',
    havePickedUp: '已提货',
    updateStatus: '更新状态',
    confirmSubmitOrderInfo: '确认更新订单信息',
    confirmSaveOrderInfo: '确认保存订单信息',

    // Invoice
    inclGST: '已含GST Invoice',
    plusGST: '加GST Invoice',
    zeroGST: '发国内(0 GST) Invoice',
    companyPhone: '公司电话',
    companyEmail: '公司邮件',
    companyAddress: '公司地址',
    customer: '顾客',
    customerNote: '客户备注',
    sellerComments: '商家留言',
    subtotal: '小计',
    totalQty: '总数',
    goods: '商品',
    goodsSubtotalInclGST: '商品小计(包含GST)',
    goodsSubtotalZeroGST: '商品小计(0 GST)',
    shippingFeePromotion: '运费活动',
    printReceipt: '小票打印',
    printA4: 'A4打印',
    close: '关闭',
    orderInvoice: '订单Invoice',

    // 物流信息
    shippingInfo: '快递信息',
    trackShipping: '查询快递',
    date: '日期',
    companyReady: '启用',
    companyWaitForReview: '等待启用',
    addCompany: '添加快递公司',
    isDefault: '是否默认',
    defaultCompany: '默认快递公司',
    addNew: '添加',
    selectDefault: '设为默认',
    selectDefaultCompany: '设置默认快递公司',
    deleteExpressCompany: '删除快递公司',

    // 仓储中心
    sku: 'SKU',
    stockValue: '库存数量',
    stockOperationType: '库存操作类型',
    stockOperationInformation: '库存操作信息',
    创建商品: '创建商品',
    添加库存: '添加库存',
    直接设置Sku商品库存: '直接设置Sku商品库存',
    关闭订单解锁库存: '关闭订单解锁库存',
    删除Sku商品: '删除Sku商品',
    人工减少库存: '人工减少库存',
    创建订单锁库存: '创建订单锁库存',
    stockTimeRange: '时间范围',
    viewAllSkuStock: '查看所有出入库记录',
    stockBeforeValue: '操作前数量',
    stockAfterValue: '操作后数量',

    // 商品品牌
    brandName: '品牌名称',
    brandLogo: '品牌Logo',
    brandInitials: '品牌首字母',
    sortWeight: '排序权重',
    createAt: '创建时间',
    brandActivity: '品牌状态',
    brandDetails: '品牌详情',
    brandReady: '启用品牌',
    brandWaitForReview: '等待启用',
    brandDeletedError: '此品牌下有商品，无法删除',

    // 发货仓库
    warehouseName: '仓库名字',
    warehouseAddress: '仓库地址',

    // 商品分类
    categoriesName: '分类名字',
    categoriesParent: '上级分类',
    categoriesDescription: '分类描述',
    categoriesSortWeight: '排序权重',
    noCategoriesParent: '不选择分类，则默认为顶级分类',
    menuOperation: '菜单操作',
    categoryIndex: '分类模块操作',
    hide: '隐藏',
    menuShow: '显示',
    categoryIndexShow: '显示',
    category_icon: '顶级分类图标',
    topCategory: '顶级分类',
    categoryDeletedError: '此分类下有商品，无法删除',
    show: '显示',
    pcMenu: 'PC导航栏',
    pcModel: 'PC首页Model',
    pcHomeCategoryImage: 'PC首页分类图片',
    mobileCategoryImage: '手机分类图片',
    customizeIcon: '自定义分类图标',
    customization: '自定义',
    pcHomeCategoryImageSize: '推荐图片最佳尺寸为 210*454 (或比例为 210:454)',
    customizeIconSize: '推荐图片最佳尺寸比例为 1:1',
    mobileCategoryImageSize: '推荐图片最佳尺寸为 270*85 (或比例为 270:85)',
    deleteImage: '删除图片',
    categoryInfoNotEnough: '分类信息填写不完整',

    // 用户中心
    ID: 'ID',
    loginName: '登陆名字',
    userGroup: '用户组',
    phoneNumber: '电话',

    // 用户详情
    password: '密码',
    confirmPassword: '确认密码',
    root: '超级管理员',
    manager: '管理员',
    pleaseSelectAUserRole: '请选择用户角色',
    update: '更新',

    // 店铺中心
    shopLogo: '店铺 Logo',
    shopName: '店铺名字',
    shopType: '店铺类型',
    shopUrls: '店铺链接',
    shopActivity: '店铺状态',
    shopReady: '上架',
    shopWaitForReview: '等待审核',
    oldPassword: '旧密码',

    // 店铺详情
    merchantName: '商店名字',
    merchantAddress: '商店地址',
    merchantContactPhone: '商店联系人电话',
    merchantContactEmail: '商店联系人邮箱',
    merchantContactPerson: '商店联系人',
    accountManager: '管理人',
    accountManagerMobilePhone: '管理人电话',
    district: '所在区',
    changePassword: '修改密码',
    shopProfile: '店铺简介',
    contactInfo: '联系文案',
    customerServiceWxId: '客服微信ID',
    shopDetailsInstroduce: '店铺详细介绍',
    pleaseChooseShopType: '请选择店铺类型',
    company: '公司',
    personal: '个人',
    myPayMid: 'IE PAY Mid',
    myPayApiKey: 'IE PAY Api Key',
    shopPaymentDetail: '线下支付信息',
    tongUrl: '同步回调URL',
    yiUrl: '异步回调URL',
    wx_appid: '微信 APP ID',
    wx_secret: '微信 Secret',
    editPassword: '修改登录密码',
    newPassword: '新密码',
    cancelPassword: '取 消',
    submitPassword: '确 定',
    welcomeImage: '微信公众号首次关注欢迎图片',
    oa_token: '微信公众号对接回调Token',
    shopQr: '店铺客服微信号二维码',
    uiTemplate: '客户端UI模板',
    selectUiTemplate: '请选择客户端UI模板',
    shopCustomHost: '自定义域名',
    contactIemall: '请联系运营人员进行修改',
    exportGoods: '导出商品',
    importGoods: '导入商品',
    exportGoodsAsXLSXFormat: '导出的商品文件为xlsx格式',
    importFormatSameAsExport: '导入文件格式要跟导出格式保持一致',
    searchHotKey: '搜索热词',
    addSearchHotKey: '添加热词',
    clickHotKey: '点击热词置顶',
    haveIepayAccout: '如已有IE PAY账号，请登录商户后台 ',
    getMid: '，至“Merchant Information” - “Online”，获取IE PAY Mid。',
    getApikey: '，至“Merchant Information” - “Online”，获取IE PAY Api Key。',
    getMidTitle: '获取IE PAY Mid',
    getApikeyTitle: '获取IE PAY Api Key',
    shopPlan: '店铺套餐详情',
    memberPlan: '店铺会员等级',
    memberPlanApply: '会员等级修改申请',
    memberPlanInfo: '未满半个月按新套餐收费，满半个月按旧套餐收费',
    applySuccessfully: '提交申请成功',
    applyFailed: '提交申请失败',
    importExcel: 'Excel导入导出',
    importFromPos: '从POS导入商品',
    importCategories: '导入分类',

    // 物流中心
    templateName: '模版名称',
    pricingMethod: '计价方式',
    defaultValue: '首重',
    defaultPrice: '起始价格',
    byWeight: '按重量',
    nzDefaultPrice: '新西兰元价格',
    cnDefaultPrice: '人民币价格',
    everyG: '每',
    shippingCosts: 'g内, 运费',
    everyGAdded: '每增加',
    shippingCostsAdded: 'g, 运费增加',
    firstWeight: '首重',
    specialSkinCareFee: '护肤品费用',
    take: '收取',
    minPackageWeight: '每包裹最小重量(千克)',
    feePerQuantity: '每(千克)运费',
    packageType: '包裹类型',
    packageRuleType: '规则类型',
    value: '数值',
    addRule: '增加规则',
    companyName: '快递公司名称',
    queryUrl: '快递公司官网',
    companyStatus: '状态',

    // 商品中心
    merchandiseId: 'ID',
    merchandiseThumbnail: '产品图',
    merchandiseName: '名字',
    merchandisePrice: '销售价格',
    merchandiseSortWeight: '排序权重',
    merchandiseActivity: '是否上架',
    merchandiseRecommend: '是否推荐',
    StockOperation: '库存操作',
    inStock: '入库',
    editStock: '编辑库存',
    productName: '商品名称',
    stock: '可售库存',
    stockAlarm: '库存预警值',
    priceMarketNz: '市场价格 (NZ$)',
    priceSoldNz: '销售价格',
    priceMarket: '市场价格 (RMB¥)',
    priceSold: '销售价格 (RMB¥)',
    cancel: '取消',
    deleteProduct: '确定删除该商品？',
    isStockAlarm: '库存报警',
    deleteWarehouse: '确定删除该仓库?',
    warehouseDeleted: '删除发货仓库成功',
    warehouseDeletedError: '此仓库下有商品，无法删除',
    warehouseDeletedFailed: '删除发货仓库失败',
    batchDeleteProducts: '批量删除选中商品',
    batchManageFreeShipping: '批量管理包邮',
    batchManagePriceBreakDiscount: '批量管理满减',
    batchManageAgentVisibility: '批量管理代理商可见',
    batchManageFreeGift: '批量管理买赠',
    PriceBreakPromotion: '满减活动',
    basePrice: '基准价格',
    freeShippingPromotion: '包邮活动',
    nonFreeShipping: '不包邮',
    freeShipping: '包邮',
    onOff: '上下架',
    all: '全部',
    on: '上架',
    off: '下架',
    soldOut: '已售罄',
    freeGift: '买赠',
    priceAsc: '价格从低到高',
    priceDesc: '价格从高到低',
    promotion: '运营活动',
    stockDetail: '库存详情',
    batchEditPrice: '批量修改价格',
    batchEditStock: '批量修改库存',
    batchSetStockAlert: '批量修改库存预警值',
    batchEditLimitTime: '批量修改限时特价',
    updateSelectedGoods: '更新所选商品为',
    confirmUpdateSelectedGoods: '确认更新选中商品为',
    updateSelectedGoodsNoPriceBreak: '更新所选商品无满减活动',
    updateSelectedGoodsFreeGift: '更新所选商品为买赠活动',
    updateSelectedGoodsNoFreeGift: '更新所选商品为无买赠活动',
    updateSelectedGoodsAgentVisible: '更新所选商品代理商可见',
    updateSelectedGoodsAgentInvisible: '更新所选商品代理商不可见',
    confirmUpdateSelectedGoodsNoPriceBreak: '确定更新所选商品无满减活动',
    confirmUpdateSelectedGoodsPriceBreak: '确定更新所选商品满减活动',
    confirmUpdateSelectedGoodsNoFreeGift: '确定更新所选商品无满赠活动',
    confirmUpdateSelectedGoodsAgentVisible: '确定更新所选商品为代理商可见',
    confirmUpdateSelectedGoodsAgentInvisible: '确定更新所选商品为代理商不可见',
    haveExpired: '已过期',

    pleaseChooseProducts: '请选择商品',
    perPage: '每页数量',
    pleaseInputNZDMarketPrice: '请输入纽币市场价格（小数点后最多两位)',
    pleaseInputCNYMarketPrice: '请输入人民币市场价格（小数点后最多两位)',
    pleaseInputNZDSalePrice: '请输入纽币销售价格（小数点后最多两位)',
    pleaseInputCNYSalePrice: '请输入人民币销售价格（小数点后最多两位)',
    pleaseInputCorrectStock: '请输入正确库存',
    pleaseInputCorrectStockAlert: '请输入正确的库存预警值',
    successDeleted: '删除成功',
    successUpdated: '更新成功',
    pleaseChooseFreeShippingPromotion: '请选择包邮活动',
    pleaseChoosePriceBreakPromotion: '请选择满减活动',
    specialPriceExpiredAsc: '限时特价到期时间',
    batchManageCoupon: '批量管理优惠券功能',
    updateSelectedGoodsCouponEnabled: '更新所选商品可用优惠券',
    updateSelectedGoodsCouponDisabled: '更新所选商品不可用优惠券',
    confirmUpdateSelectedGoodsCouponEnabled: '确定更新所选商品可用优惠券',
    confirmUpdateSelectedGoodsCouponDisabled: '确定更新所选商品不可用优惠券',
    batchSpecialPrice: '批量特价',
    batchManageSold: '批量管理上下架',
    batchManagePromote: '批量管理推荐',
    batchUpdateBestUseBefore: '批量更新保质期',
    batchUpdateSpecialPrice: '批量修改特价',
    updateSelectedGoodsEnableSold: '更新所选商品为上架',
    updateSelectedGoodsDisableSold: '更新所选商品为下架',
    updateSelectedGoodsEnablePromote: '更新所选商品为推荐',
    updateSelectedGoodsDisablePromote: '关闭所选商品的推荐',
    updateSelectedGoodsBestUseBeforeAt: '批量更新所选产品保质期',
    confirmUpdateSelectedGoodsSoldEnable: '确定更新所选商品上架',
    confirmUpdateSelectedGoodsSoldDisable: '确定更新所选商品下架',
    confirmUpdateSelectedGoodsPromoteEnable: '确定更新所选商品为推荐',
    confirmUpdateSelectedGoodsPromoteDisable: '确定关闭所选商品的推荐',
    confirmUpdateSelectedGoodsBestUseBeforeAt: '确定批量更新所选产品保质期',

    pickUpOnlyWarning:
      '该功能用于团购商品, 如果选中后该商品只能单独购买并不能邮寄, 请谨慎使用',
    removePropertyItem: '删除商品规格（恢复商品至无规格）',

    // 添加商品
    chooseCategory: '选择商品分类',
    basicInformation: '商品基本信息',
    merchandiseDetails: '商品描述',
    merchandiseAttributes: '商品属性',
    merchandiseAlbum: '产品图册',
    distributionSettings: '分销设置',
    otherInformation: '其他信息设置',
    productSubtitle: '商品副标题',
    selectedCategories: '选择分类',
    productBrand: '商品品牌',
    shippingWarehouse: '发货仓库',
    noData: '暂无数据',
    expressType: '快递类型',
    expressTemplate: '运费模板',
    discountPlan: '折扣方案',
    expressMax: '快递最大装载量',
    measurement: '计量单位',
    enterMeasurement: '请输入计量单位，例如：罐、袋、瓶、盒等',
    productSPUWeight: '商品SPU快递重量',
    productSKUWeight: '商品SKU快递重量',
    syncPosData: '同步POS库存',
    SpuWeightNotice: '如果SKU重量为0, 则使用SPU重量',
    productLength: '商品快递长度',
    productWidth: '商品快递宽度',
    productHeight: '商品快递高度',
    gram: '克',
    bestUseBefore: '保质期',
    Latest: '最新',
    keyword: '产品关键字',
    productStock: '商品库存',
    productSku: '条形码',
    option: '选填',
    topButton: '置顶按钮',
    deleteButton: '删除按钮',
    level1: '一级分销获得积分',
    level2: '二级分销获得积分',
    level3: '三级分销获得积分',
    selling: '上架',
    recommended: '推荐',
    isCredit: '允许余额付款',
    isAlone: '单独购买',
    createProduct: '创建',
    finish: '完成',
    next: '下一步',
    productProperty: '商品规格',
    addProductProperty: '添加商品规格',
    addPropertyItem: '添加规格项目',
    productPropertyName: '规格名',
    productPropertyValue: '规格值',
    // 商品列表
    goodsReady: '上架',
    goodsWaitForReview: '下架',
    recommend: '推荐',
    notRecommended: '普通',
    merchandiseStock: '库存',
    reset: '重置',
    skuWeight: '商品快递重量',
    goodsSort: '商品排序',
    pleaseChoose: '请选择',

    // CMS
    moduleName: '模块名称',
    moduleActivity: '模块状态',
    moduleReady: '显示',
    moduleWaitForReview: '隐藏',

    // 提示信息
    switchLanguageSuccess: '切换语言成功',

    // 内容中心
    enable: '启用',
    sort: '排序',
    navigateName: '导航名称',
    bannerTitle: 'Banner标题',
    hotSalesTitle: '热销推荐标题',
    bannerActivity: '手机状态',
    isAgentVisible: '代理商可见',
    agentName: '分销店名',
    bannerImg: 'Banner图片',
    linkUrl: 'Url链接',
    bannerImage: 'Banner图片',
    hotSalesImage: '热销推荐图片',

    actionUrl: '手机Url链接',
    relatedCategories: '关联商品分类',
    dragFiles: '将文件拖到此处，或',
    uploadFiles: '上传文件',
    clickUpload: '点击上传',
    fileLimit: '只能上传jpg/png文件，且不超过2mb',
    lessThan2MB: '文件必须小于2MB',
    deleteBanner: '确定删除该广告Banner？',
    noticeConfirm: '提 示',
    deleteCancel: '取 消',
    deleteConfirm: '确 定',
    deletePage: '确定删除该页面?',
    pageName: '页面名称',
    loginEmail: '登录邮箱',
    shopDomain: '店铺网址',
    pageTitle: '标题',
    pageSuffix: '后缀',
    pageStatus: '状态',
    pageDetail: '页面内容',
    // bannerActivity: 'Banner状态',
    bannerReady: '启用Banner',
    bannerWaitForReview: '等待启用',
    relatedTo: '关联至',
    relatedBrands: '关联商品品牌',
    relatedSearch: '搜索关键字',
    relatedCustomize: '自定义',
    uploadFilesSize: 'Banner最佳尺寸像素为 1000x384（或比例为125:48）',
    aboutUsImgSizeNotice: 'Banner最佳尺寸像素为 100(宽) * 80(高)',
    relatedActivity: '关联活动专区',
    activityUrl: '活动专区',
    showInStoreWiki: '是否显示在商城百科',
    pageUrl: '页面URL',
    pcActionUrl: 'PC Url链接',
    mobileActionUrl: '手机Url链接',
    bannerPCActivity: 'PC状态',
    hotSalesImageSize: '推荐图片尺寸最佳比例为 1:1',

    // 搜索
    inputSearch: '输入搜索',
    searchInfo: '商品名称',
    merchandiseCategories: '商品分类',
    merchandiseBrand: '品牌',
    selectBrand: '请选择品牌',
    searchSubmit: '查询',

    // 交易中心
    transactionId: '交易流水号',
    enterTransactionId: '输入交易流水号',
    orderTitle: '订单标题',
    createTime: '创建时间',
    finishTime: '完成时间',
    paymentStatus: '支付状态',
    customerName: '用户账号',
    paymentAmount: '支付金额',
    viewTransaction: '查看交易记录',
    transactionRecords: '交易记录',
    tradeNo: '订单号',
    payType: '支付方式',
    payStatus: '支付状态',
    transactionMessage: '支付记录',
    tradeCreateTime: '交易时间',
    paymentType: '交易类型',

    // 分销中心
    distributionId: '分销记录号',
    distributionLevel: '分销等级',
    distributionPoint: '分销获取积分',
    distributionSuperior: '分销上级用户名',
    distributionSubordinate: '分销下级用户名',
    productSuperior: '分销产品上级地址',
    productSubordinate: '分销产品下级地址',
    type: '类型',
    agentMsg1:
      '目前是测试模块，《分销平台使用协议》和收费方案会在模块正式版上线时发布。如不选择该服务，现有已建代理店会被限制使用',
    accountMoreThan6Characters: '登录账号必须大于6位英文字母或数字',

    // 会员中心
    memberIdSearch: '输入搜索',
    enterMemberId: '用户账号',
    memberNameSearch: '用户昵称',
    enterMemberName: '输入用户昵称',
    registrationDateSearch: '注册时间',
    enterRegistrationDate: '注册时间',
    memberId: '用户ID',
    username: '用户名',
    usernameRequirement: '用户名(最少6位英文字母)',
    memberName: '用户昵称',
    memberLevel: '会员等级',
    memberPoint: '会员积分',
    totalAmount: '消费金额',
    orderQuantity: '订单数量',
    registrationDate: '注册时间',
    memberDetail: '会员信息',
    memberOrder: '订单信息',
    memberCredit: '账户余额',
    memberCreditEdit: '账户余额',
    editCredit: '账户余额编辑',
    creditOperationLog: '账户余额操作日志',
    creditAmount: '操作金额',
    createPlan: '创建方案',
    save: '保存',
    editLevel: '编辑等级',
    level: '等级',
    name: '姓名',
    levelName: '等级名称',
    editName: '编辑名称',
    wechatImg: '微信头像',
    wechatName: '微信昵称',
    editCreditButton: '修改余额',
    addCredit: '增加余额',
    reduceCredit: '减少余额',
    comment: '备注',
    sortByTotalOrderSum: '消费金额排序',
    PeriodtotalSpend: '总金额',
    PeriodtotalOrders: '总订单数',
    successSpend: '成功订单总金额',
    successOrders: '成功订单数',
    couponBatchIssued: '批量发放优惠券成功',
    couponBatchIssueFailed: '批量发放优惠券失败',
    memberRemarks: '会员备注',
    editMemberRemarks: '会员备注修改',
    userRemarks: '会员备注',
    editUserRemarks: '会员备注修改',
    miniProgramInfo: '微信小程序信息',
    青铜: 'Level 1',
    白银: 'Level 2',
    黄金: 'Level 3',
    铂金: 'Level 4',
    钻石: 'Level 5',
    星耀: 'Level 6',
    王者: 'Level 7',

    // 店员中心
    assistantIdSearch: '店员ID/店员账号',
    assistantId: '店员ID',
    createdAt: '创建时间',
    phone: '手机号码',
    addRole: '增加角色',
    role: '角色',
    email: '电子邮箱',
    editAssistant: '修改',
    editAssistantDetail: '修改店员信息',
    writerList: '核销员管理',
    useDifferentName: '错误, 请尝试使用不同的用户名',
    englishOnly: '请使用英文字符',

    // 角色权限列表
    roleDescription: '角色描述',
    roleName: '角色名字',
    passwordUnmatch: '两次输入密码不一致！',
    passwordCanNotBeEmpty: '密码不能为空',
    RoleDuplicate: '角色重复！',
    订单管理员: 'Orders administrator',
    商品管理员: 'Merchandise administrator',
    仓储中心查询: 'Stock enquiry',
    内容管理: 'CMS management',
    店铺基础信息管理员: 'Shop basic information administrator',
    '会员管理员(无余额）': 'Members administrator(No balance)',
    店员权限管理: 'Assistant permission management',
    订单查询: 'Order enquiry',
    物流管理员: 'Express administrator',
    代理管理: 'Agent management',
    优惠券管理: 'Coupon management',
    '会员管理员(余额）': 'Members administrator(balance)',
    交易查询: 'Transaction enquiry',
    '管理订单、配货、发货、退款和查询功能': 'Manage orders, distribution, delivery, refund and query functions',
    '管理品牌、商品分类、发货仓库、商品管理、入库管理。': 'Manage brand, product classification, shipping warehouse, product management, and warehousing management.',
    '查询商品出入库记录。': 'Query the record of goods in and out of the warehouse.',
    '店铺内容管理和banner管理。': 'CMS management and banner management.',
    '管理店铺基础信息维护': 'Manage store basic information maintenance',
    '管理会员等级、折扣方案、会员等级': 'Manage member levels and discount plans',
    '添加店员，管理店员权限、查询角色权限': 'Add shop assistants, manage shop assistant permissions, query role permissions',
    '只能看到已付款和已发货订单，并能编辑订单状态。': 'Only see paid and shipped orders, and edit the order status.',
    '管理物流公司、快递模板': 'Manage courier companies and express templates',
    '添加代理和管理代理返佣': 'Add agent and manage agent rebate',
    '编辑会员余额': 'Edit member balance',
    '交易查询流水列表': 'Transaction query, running list',

    // 核销
    writerId: '核销员ID',
    writerName: '核销员名字',
    writerCode: '核销码',
    writerLog: '核销记录',
    editWriter: '修改',
    editWriterDetail: '修改核销员信息',
    addWriter: '添加核销员',
    codeIsNumber: '核销码应为4位数字',
    fourNumber: '四位数字',

    // 统计中心
    dataUpdatedAt: '数据更新于',
    statisticsNotice: '注：统计一天时间为中国时间的 00:00 至 23:59',
    keyIndicator: '主要指标',
    totalToday: '今日累积',
    totalYesterday: '昨日累积',
    totalThisMonth: '当月累积',
    totalPrevMonth: '上月累积',
    trend: '趋势',
    detailData: '详细数据',
    day: '日',
    week: '周',
    month: '月',
    creditPay: '余额支付',
    onfflinePay: '线下支付',
    PoliPay: 'PoliPay',
    UnionPay: '银联',
    refundAmount: '退款总额',
    totalSales: '订单销售总额',
    totalOrdersToday: '今日累积订单',
    totalOrderYesterday: '昨日累积订单',
    totalOrderCurrentMonth: '当月累积订单',
    totalOrderPrevMonth: '上月累积订单',
    orderPlaced: '下单数',
    orderPaid: '付款订单数',
    orderPayRate: '订单支付率',
    averageOrderValue: '订单平均金额',
    topOrderValue: '最高订单金额',
    statisticsDuration: '统计时间',
    thirtydaysSales: '30天总销量',
    historicalSales: '历史总销量',
    searchGoods: '搜索商品',
    goodsImage: '商品图片',
    salesVolume: '销量',
    salesRank: '销售排行',
    newMemberToday: '今日新用户',
    newMemberYesterday: '昨日新用户',
    newMemberCurrentMonth: '当月新用户',
    totalMembers: '总用户数',
    newMemberCount: '新注册用户数',

    // 运营中心
    FreeExpressDetails: '包邮活动详情',

    customerMustBindEmailOrPhone: '客户须绑定邮箱或手机号',
    onlyShowBenchmarkCurrency: '前端只显示基准货币',
    allowPickUp: '允许自取',
    allowShipping: '允许快递',
    isShowSender: '显示发货人',
    isAgeRestriction: '18+年龄限制',
    International: '全球',
    newZealand: '新西兰',
    disableShippingNotice: '不允许快递就是只自取',
    businessScope: '商业范围',
    isShowCourierWeight: '显示商品重量',
    pickUpOrShipping: '自取和快递选项不能同时关闭',
    idRequired: '身份证必填',
    isDeleteEnable: '是否可删除',
    canDelete: '可以删除',
    cannotDelete: '不可删除',
    gift: '买赠活动',
    limitedTimeSpecial: '限时特价',
    couponCollectCenter: '领券中心',

    // 支付方式
    wechatPay: '微信支付',
    alipay: '支付宝',
    polipay: 'POLi',
    creditCard: '信用卡',
    bankTransfer: '银行转账',
    alipayQrCode: '支付宝二维码',
    alipayOnline: '支付宝网页',
    alipayMobileOnline: '支付宝移动网页',
    wechatQrCode: '微信二维码',
    wechatMobileOnline: '微信移动网页',
    wechatPremiumPay: '微信高级支付',
    unionpay: '云闪付',
    paypal: 'PayPal',

    // 代理商
    newAgent: '新增代理商',
    initPassword: '初始密码',
    contactPerson: '联系人',
    contactPhone: '联系电话',
    contactWechat: '联系微信',
    digitalWallet: '电子钱包',
    active: '激活',
    contactAddress: '地址',
    domainPrefix: '域名前缀(英文)',
    domainPrefixRequirement: '域名前缀(最少4位数英文字母)',
    agreePolicy: '同意协议',
    distributorAgreement: '分销平台使用协议',
    agentProfit: '分销利润',
    withdrawAmount: '提现金额',
    withdrawCurrency: '提现币种',
    withdrawChannel: '提现渠道',
    accountNumber: '银行账号',
    submitTime: '提交时间',
    withdrawDocument: '提现材料',
    balance: '余额',
    status: '状态',
    agentApplication: '代理商自助申请',
    agentApplicationUrl: '代理商自助申请链接',
    defaultAgentLoginURL: '默认代理商登录地址:',
    selectOrUploadLogo: '请选择默认Logo，或自行上传',
    agentUsername: '登录账号',
    agentUsernameRequirement: '登录账号(最少6位英文字母或数字)',
    contactEmail: '联系邮箱',
    viewDetail: '查看详情',
    allDocs: '全部材料',
    clickToUpload: '点击上传',
    markaspaid: '标记为已付',
    address: '地址',
    confirmFinalizeWithdraw: '确认完成提现?',
    withdrawNotice1:
      '请注意:上传转账凭证以后, 再点击转账, 表示商户已经完成转账',
    withdrawNotice2:
      '如出款为其他币种,建议通过安亿金融IEMONEY LIMITED进行货币转换并汇出(通常需要3个工作日)',
    withdrawNotice3:
      '确认将代理商的该币种提现需求信息通过email发送给IEMONEY? 您将很快收到IEMONEY客服的电话来协助您完成该币种的换汇提现需求',

    // 电子钱包
    time: '时间',
    transactionNo: '流水号',
    evidenceOfPayment: '转账凭证',

    // 优惠券
    createNewCoupon: '创建新优惠券',
    collectCoupon: '移动端领券中心',
    pcCollectCoupon: 'PC端领券中心',
    couponName: '优惠券名称',
    couponExpiryTime: '到期时间',
    couponCode: '优惠券领取码',
    effectiveTime: '有效时间段',
    couponType: '优惠券类型',
    numberOfIssues: '发放数量',
    couponDetails: '优惠券内容',
    showInCollection: '显示在领取中心',
    couponRemark: '备注',
    details: '详情',
    newCoupon: '新建优惠券',
    editCoupon: '编辑优惠券',
    collectCouponUrl: '移动端优惠券领取URL',
    pcCollectCouponUrl: 'PC端优惠券领取URL',
    couponCondition: '优惠券满多少金额可用',
    couponDeduction: '优惠券抵扣金额',
    couponDiscount: '优惠券折扣金额',
    couponEffectiveDate: '优惠券有效时间',
    endCoupon: '停用',
    couponTotalNumber: '优惠券总发放数量',
    unlimitedNumber: '不填代表无限数量',
    collectedCoupon: '已被领取优惠券数量',
    usedCoupon: '已被使用优惠券数量',
    numberPerCustomer: '每个用户限领取数量',
    isShowedInCollection: '是否显示在领取中心',
    autoCode: '不填则自动创建',
    numberOfCollect: '已领取数',
    numberOfUsed: '已使用',
    averagePrice: '使用订单平均价格',
    sumOfOrder: '使用订单总和',
    couponOrder: '使用该优惠券的订单列表',
    priceOfOrder: '订单价格',
    deduction: '抵扣',
    discount: '折扣',
    infoCondition: '订单满NZD $',
    infoDeduction: '减',
    infoDiscount: '打',
    infoSale: '折',
    deductionCondition: '不可大于使用条件',
    discountCondition: '折扣范围在 0.01-0.99 之间',
    couponEnabled: '是否可用于优惠券',
    selectCoupon: '选择优惠券',
    sendCoupon: '批量发放优惠券',
    pleaseChooseMembers: '请选择会员',
    discountTip: '例如：设置折扣金额为0.8，则商品折扣为8折',
    deleteCoupon: '确定删除此优惠券？',

    // 公告中心
    updatedAt: '更新时间',
    noticeContent: '公告内容',
    deleteNotice: '确定删除该公告？',
    addNotice: '新增公告',
    updateNotice: '修改公告',
    // 保质期
    bestUseAt: '保质期',
    to: '至',
    startDate: '开始日期',
    iemallGuide: '操作手册',
    post: '邮寄',
    selfOperated: '自营',
    batchOperation: '批量操作',
    createDiscountPlan: '新建折扣方案',
    chooseShelfLife: '选择保质期',
    optionShelifLife: '(选填，不填时默认为“最新”)',
    defaultSales: '默认销售量',
    defaultViews: '默认浏览量',
    actualSales: '实际销售量',
    actualViews: '实际浏览量',
    displaySales: '显示销售量',
    displayViews: '显示浏览量',
    limitedTimeSpecialDeadline: '限时特价截止时间',
    chooseDate: '选择日期时间',
    eventHasExpired: '活动已过期',
    return: '返回',
    isThereAGiveaway: '是否有赠品',
    registrationDateRange: '注册时间范围',
    batchExportMemberInfo: '批量导出用户信息',
    wechatInfo: '微信信息',
    wechatNickname: '昵称',
    wechatSex: '性别',
    wechatMale: '男性',
    wechatFemale: '女性',
    wechatUnknown: '未知',
    country: '国家',
    province: '省',
    city: '城市',
    pleaseSelectMembers: '请选择会员',
    warning: '警告',
    emailIsVerified: '邮箱已验证',
    emailIsNotVerified: '邮箱未验证',
    refund2Credits: '退回到余额',
    refund2OPM: '原路退回',
    refund2Offline: '线下操作退款',
    refundType: '退回方式',
    MyPayRefundFailedInsufficientFunds: '商户MyPAY账户余额不足，退款失败',
    DirectionOnMyPayInsufficientFunds: '请前往MyPAY账户充值',
    PayPalRefundFailedInsufficientFunds: 'PayPal账户余额不足，退款失败',
    DirectionOnPayPalInsufficientFunds: '请前往PayPal账户充值',
    OperationSucceed: '操作成功',

    未付款: '未付款',
    部分付款: '部分付款',
    '已付款（待发货）': '已付款（待发货）',
    配货中: '配货中',
    '已发货（待完成）': '已发货（待完成）',
    '未付款已发货（待完成）': '未付款已发货（待完成）',
    交易完成: '交易完成',
    申请退款: '申请退款',
    退款完成: '退款完成',
    用户取消订单后关闭: '用户取消订单后关闭',
    退款完成后关闭: '退款完成后关闭',
    管理员关闭订单并退款: '管理员关闭订单并退款',
    管理员关闭订单: '管理员关闭订单',
    支付超时关闭订单: '支付超时关闭订单',
    已关闭: '已关闭',
    print: '打印',

    // 通知管理
    商户: '商户',
    客户: '客户',
    分销商: '分销商',
    创建订单: '创建订单',
    支付订单: '支付订单',
    拒绝退款: '拒绝退款',

    // banking
    bankingSolutions: '全球收单'
  },
  tagsView: {
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  dashboard: {
    店铺链接: '店铺链接',
    快捷功能: '快捷功能',
    店铺管理: '店铺管理',
    产品管理: '产品管理',
    产品分类: '产品分类',
    订单中心: '订单中心',
    仓储管理: '仓储管理',
    Banner管理: 'Banner管理',
    首页推荐: '首页推荐',
    运营中心: '运营中心',
    新增会员: '新增会员',
    新增订单: '新增订单',
    收入: '收入',
    今日新增会员数: '今日新增会员数',
    昨日新增会员数: '昨日新增会员数',
    今日订单数: '今日订单数',
    昨日订单数: '昨日订单数',
    今日收入: '今日收入',
    昨日收入: '昨日收入',
    会员数量: '会员数量',
    商品数量: '商品数量',
    订单数量: '订单数量',
    查看详情: '查看详情',
    销售统计: '销售统计',
    日期: '日期',
    本月销售总额: '本月销售总额',
    同比上月: '同比上月',
    本周销售总额: '本周销售总额',
    同比上周: '同比上周',
    商品受欢迎统计: '商品受欢迎统计',
    最近订单统计: '最近订单统计',
    今日: '今日',
    最近30天: '最近30天',
    最近10笔: '最近10笔',
    最近20笔: '最近20笔',
    商品名称: '商品名称',
    收藏量: '收藏量',
    成交次数: '成交次数',
    订单编号: '订单编号',
    订单状态: '订单状态',
    订单金额: '订单金额',
    开始日期: '开始日期',
    结束日期: '结束日期',
    至: '至',
    请完成开户: '请完成开户',
    完成: '完成',
    关闭: '关闭',
    上一步: '上一步',
    下一步: '下一步',
    driver1Name: '如何创建新商品',
    driver1Desc: '点击此图标进入商品管理界面，进行商品创建，创建商品前，请先创建该商品对应的分类和品牌',
    driver2Name: '如何创建新品牌',
    driver2Desc: '点击此图标进入品牌管理界面，进行品牌创建',
    driver3Name: '如何创建新分类',
    driver3Desc: '点击此图标进入分类管理界面，进行分类创建',
    手机端链接: '手机端链接',
    电脑端链接: '电脑端链接',
    自定义链接: '自定义链接',
    操作手册链接: '操作手册链接',
    手机端二维码: '手机端二维码',
    复制: '复制',
    复制成功: '复制成功'
  },
  openShop: {
    null: 'null',
    零售业基础方案: '零售业基础方案。<br />\n包含网络服务，收银设备。<br />',
    零售业高级方案: `零售业高级方案。<br /> \n包含网络服务，高性能收银设备。`,
    服务业基础方案: '服务业基础方案。<br />\n包含网络服务，收银设备。',
    服务业高级方案: '服务业高级方案。<br />\n包含网络服务，高性能收银设备。',
    MieWirelessinternet52Unlimited_str: '无线网络服务',
    MieWirelessinternet52Unlimited: 'Mie Wireless internet 5/2 Unlimited.<br/>5MB/S无限流量网络服务。支持整店全设备接入。<br />\n适用于中小型店面全网络覆盖。<br />\n',
    SUNMID2sLite_str: `点餐屏幕`,
    SUNMID2sLite: `SUNMI D2s Lite.<br/>商米15.6英寸触屏智能台式收银机。<br />\n睿智酷黑极简机身，提升门店格调和品质。<br />\n`,
    TaptouchS300H_str: `打印机`,
    TaptouchS300H: `Taptouch S300H.<br/>Taptouch高速热敏纸打印机。<br />\n支持Windows, Android, Linux系统。<br />\n`,
    TaptouchC3540_str: `收银柜`,
    TaptouchC3540: `Taptouch  C3540.<br/>Taptouch 40cm*35cm钱箱。<br />\n大空间，长寿命。<br />\n`,
    TaptouchN2050_str: `扫码机`,
    TaptouchN2050: `Taptouch N2050.<br/>Taptouch台式扫码器。<br />\n识别率高，速度快。<br />\n`,
    HospitalityFastGrow_str: `收银系统`,
    HospitalityFastGrow: `Hospitality Fast Grow.<br/>Taptouch专为咖啡/外卖/饭店等开发的专业收银机操作系统。<br />\n`,
    MieWirelessinternet205Unlimited_str: `无线网络服务`,
    MieWirelessinternet205Unlimited: `Mie Wireless internet 20/5 Unlimited.<br/>20MB/S无限流量网络服务。支持整店全设备接入。<br />\n适用于中大型店面全网络覆盖。<br />\n`,
    SUNMIT2sDualTouch_str: `点餐屏幕`,
    SUNMIT2sDualTouch: `SUNMI T2s Dual Touch.<br/>商米触屏智能台式收银机。双显示屏(15.6英寸主屏+10.1英寸客显)。<br />\n性能卓越，助力商户更好的经营成长。<br />\n`,
    SmartBox_str: `扫码小白盒`,
    SmartBox: `Smart Box.<br/>Inspiry扫码小白盒。<br />\n内嵌全套纽币支付体系，即扫即付。<br />\n`,
    选择套餐: '选择套餐',
    选择模板: '选择模板',
    选择支付渠道: '选择支付渠道',
    选择商品: '配置套餐',
    结算: '结算',
    成功提交: '成功提交',
    确定: '确定',
    以下是官方套餐推荐服务选择: '以下是官方套餐推荐服务选择',
    官方根据各个场景专业化推荐套餐: '官方根据各个场景专业化推荐套餐',
    以下是个性化服务选择: '以下是个性化服务选择',
    可根据自己店铺所需个性化定制: '可根据自己店铺所需个性化定制',
    套餐介绍: '套餐介绍',
    系统介绍: '系统介绍',
    查看介绍: '查看介绍',
    POS系统: 'POS系统',
    POS硬件机: 'POS硬件机',
    EFPOS系统: 'EFPOS系统',
    配件: '配件',
    需线下支付: '需线下支付',
    网络服务: '网络服务',
    线下商品支付: '线下商品支付',
    绑定的支付渠道: '绑定的支付渠道',
    已选模板: '已选模板',
    已选套餐: '已选套餐',
    已选商品: '已选商品',
    线下支付总价: '线下支付总价',
    线上支付总价: '线上支付总价',
    订阅费: '订阅费每月',
    每月: '每月',
    立即线上支付: '立即线上支付',
    提交成功: '提交成功',
    取消: '取消',
    确定使用: '确定使用',
    合计总价: '合计总价',
    返回dashboard: '返回 dashboard',
    配置说明: '配置说明'
  },
  openShopSettle: {
    账单结算: '账单结算',
    应缴周期数: '应缴周期数',
    期: '期',
    线下商品支付: '线下商品支付',
    绑定的支付渠道: '绑定的支付渠道',
    已选模板: '已选模板',
    已选商品: '已选商品',
    线下支付总价: '线下支付总价',
    线上支付总价: '线上支付总价',
    订阅费: '订阅费',
    立即线上支付: '立即线上支付',
    支付信息: '支付信息',
    已支付: '已支付',
    未支付: '未支付'
  },
  bankingSolutions: {
    title: '全球收单',
    desc: '轻轻一点即可选择我们的全球收单解决方案',
    multiCurrencyTitle: '多币种账号',
    multiCurrencyDesc: '轻松开立多币种银行账号',
    rewardsTitle: '专属奖励',
    rewardsDesc: 'IE Shop商户专属福利',
    IntegrationTitle: '无缝接入',
    IntegrationDesc: '您的数据直连银行',
    supportTitle: '贴心服务',
    supportDesc: '我们客服随时为您服务',
    mieCard: 'Mie Card',
    mieCardDesc: '专门针对初创和小微企业的银联卡，可充值，无需个人担保或者抵押，提供有竞争力的权益',
    points: '获取积分',
    pointsDesc: '使用Mie Card，每消费$3000，即可获得25,000积分'
  }
}
